import { z } from 'zod';

import { BehaviorSettings } from '../models';

export const BasePType = z.object({
  id: z.number().optional(),
  revisionId: z.number().optional(),
  type: z.string(),
  status: z.boolean(),
  parentType: z.string().optional(),
  uuid: z.string().nullable().optional(),
  behaviorSettings: z.optional(BehaviorSettings),

  // Angular Config
  // This is a free-text field coming from CMS used to house any visual configuration
  // that's not covered by any of the properties above.
  angularConfig: z.any().nullable().optional(),

  // fields to move elsewhere?
  // I don't like having all these in the base, but part of having to have this here
  // rather than down the chain is because it doesn't seem like we can narrow out the
  // UnknownPType class where we're using a string for the type field rather than an enum
  marginClass: z.string().optional().nullable(),
  overflow: z.string().optional().nullable(),
  paddingTop: z.string().optional().nullable(),
  paddingBottom: z.string().optional().nullable(),
  paddingRight: z.string().optional().nullable(),
  paddingLeft: z.string().optional().nullable(),
  displayFlex: z.string().optional().nullable(),
  flexDirection: z.string().optional().nullable(),
  fbiMobile: z.string().optional().nullable(),
  fbiTablet: z.string().optional().nullable(),
  fbiDesktop: z.string().optional().nullable(),
  flexboxItemMobileOrder: z.string().optional().nullable(),
  flexboxItemTabletOrder: z.string().optional().nullable(),
  flexboxItemDesktopOrder: z.string().optional().nullable(),
  displayClass: z.string().optional().nullable(),
  visibility: z.string().optional().nullable(),
  mobileCenter100: z.string().optional().nullable(),
  videoMaxWidth: z.string().optional().nullable(),

  bottomBorder: z.boolean().optional(),
  topBorder: z.boolean().optional(),
  leftBorder: z.boolean().optional(),
  rightBorder: z.boolean().optional(),
  roundedCorner: z.string().optional().nullable(),
});

export type BasePType = z.infer<typeof BasePType>;
